import { Component } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { MessagingChannelHelperService } from '../messaging-channel-helper.service'

@Component({
  selector: 'app-connect-facebook-dialog',
  templateUrl: './connect-facebook-dialog.component.html',
  host: { class: 'modal-content' },
  styleUrls: ['./connect-facebook-dialog.component.scss'],
})
export class ConnectFacebookDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConnectFacebookDialogComponent>,
    private helper: MessagingChannelHelperService
  ) {}

  close() {
    this.dialogRef.close()
  }

  onConnect() {
    this.helper.connect('facebook').subscribe(() => {
      this.close()
    })
  }
}
